export function getPhones(contact_method_associations) {
  return contact_method_associations.map(cma => cma.phone).filter(Boolean)
}
